import { useTranslation } from "react-i18next";
import { Markdown } from "../Markdown";
import { SignaturePad } from "../SignaturePad";

export function VaccinationEducationFields({
  text,
  confirmed,
  signature,
  onConfirmedChange,
  onSignatureChange,
}: {
  text: string;
  confirmed: boolean;
  signature: string;
  onConfirmedChange: (confirmed: boolean) => void;
  onSignatureChange: (signature: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <div className="rounded-lg border p-5 text-sm leading-7 text-gray-700">
        <Markdown>{text}</Markdown>
      </div>
      <label className="flex items-start gap-3 rounded-lg border p-4">
        <input
          type="checkbox"
          className="mt-0.5 size-5 shrink-0 accent-blue-600"
          checked={confirmed}
          onChange={(event) => onConfirmedChange(event.target.checked)}
          required
        />
        <span className="font-medium">{t("Ich bestätige, dass ich über die Impfung aufgeklärt wurde.")}</span>
      </label>
      <div className="space-y-2">
        <p className="font-semibold">{t("Unterschrift")}</p>
        <SignaturePad value={signature} onChange={onSignatureChange} />
      </div>
    </div>
  );
}
